// extracted by mini-css-extract-plugin
module.exports = {"towerBox":"tower_towerBox__1kRU0"};